import { CompilationManifest } from '@msdk/definitions'

import { ModuleNotFoundError } from '../models'

/**
 * The function `providerFromManifest` extracts provider and URL information from a compilation
 * manifest based on a given module name.
 * @throws if the module is not found it will throw a `ModuleNotFoundError`
 */
export function providerFromManifest(manifest: CompilationManifest, moduleName: string) {
  const module = manifest.modules.find((m) =>
    (m.components ?? []).some((c) => c.entityName === 'CUSTOM' && c.formName === moduleName),
  )

  if (!module) {
    throw new ModuleNotFoundError(`Module not found for custom component: ${moduleName}`)
  }

  const provider = module?.name.replace('Generated', '') as string
  const url = module.url
  return { provider, url }
}
